import { useState } from "react";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";

import MuiDialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import ImageList from "@mui/material/ImageList";
import MuiImageListItem from "@mui/material/ImageListItem";

import CloseIcon from "@mui/icons-material/Close";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

import { Black, White } from "src/styles/color";
import { checkNotEmpty } from "src/common";

import Button from "src/components/core/Button";
import LabelSection from "src/components/core/LabelSection";
import Checkbox from "src/components/core/Checkbox";
import { imageUrlToFile } from "src/common/file";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 16,
    // borderRadius: "16px 16px 4px 4px",
    position: "relative",
  },
  "& .MuiDialogContent-root": {
    maxHeight: 500,
    border: 0,
    padding: 24,
    paddingBottom: 0,
  },
  "& .MuiDialog-container": {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: 550,
    },
  },
  "& .MuiDialogActions-root": {
    justifyContent: "center",
  },
  "& .MuiDialogActions-root>:not(:first-of-type)": {
    marginLeft: 24,
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiPaper-root": {
      margin: 24,
    },
    "& .MuiDialogContent-root": {
      padding: 16,
      paddingTop: 0,
    },
    "& .MuiDialogActions-root": {
      padding: 16,
    },
  },
}));

const ImageListItem = muiStyled(MuiImageListItem)(({ theme }) => ({
  position: "relative",
  cursor: "pointer",
  borderRadius: 8,
  overflow: "hidden",
  border: `2px solid transparent`,
  "&:hover": {
    border: `2px solid #9ad3f0`,
  },
}));

const CloseButton = styled(IconButton)`
  &.MuiIconButton-root {
    position: absolute;
    top: 16px;
    right: 16px;
    color: ${Black};
  }
`;

const AdBoxContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  width: 550px;
  height: 110px;
  z-index: 3000;
`;

const ImageGalleryDialog = ({ suggestImages = [], onSubmit, onClose }) => {
  const [selectedImages, setSelectedImages] = useState(null);

  const handleOnSubmit = async () => {
    // fetch image url to file object
    const file = await imageUrlToFile(selectedImages, "suggest-image.jpeg");
    onSubmit(file);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={true}
      >
        <DialogContent
          sx={{
            p: 3,
            width: "100%",
            "::-webkit-scrollbar": {
              display: "none",
            },
            "& .MuiBox-root": {
              maxWidth: "500px",
              mx: "auto",
            },
          }}
        >
          <CloseButton aria-label="close" onClick={onClose} sx={{ zIndex: 10 }}>
            <CloseIcon fontSize="small" />
          </CloseButton>

          <LabelSection
            title="เลือกภาพห้องจากคลัง"
            style={{ marginBottom: 0 }}
            headerStyle={{ marginBottom: 16 }}
          >
            <ImageList
              sx={{ width: 500, maxHeight: "calc(100dvh - 420px)", m: 0 }}
              cols={3}
              rowHeight={164}
            >
              {suggestImages.map((item) => (
                <ImageListItem
                  key={item?._id}
                  onClick={(e) => {
                    setSelectedImages(item?.docUrl);
                  }}
                >
                  <img
                    srcSet={`${item.docUrl}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    src={`${item.docUrl}?w=164&h=164&fit=crop&auto=format`}
                    alt={item.originalFileName}
                    loading="lazy"
                  />

                  <Checkbox
                    name="select-image-checkbox"
                    sx={{
                      position: "absolute",
                      top: 8,
                      left: 8,
                      p: 0,
                      // backgroundColor: White,
                      color: White,
                      "&.Mui-checked": {
                        color: "#9ad3f0",
                      },
                    }}
                    icon={<RadioButtonUncheckedIcon />}
                    checkedIcon={<RadioButtonCheckedIcon />}
                    checked={selectedImages === item.docUrl || false}
                    // onChange={(e) => {
                    //   setSelectedImages(item.docUrl);
                    // }}
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </LabelSection>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            disabled={!checkNotEmpty(selectedImages)}
            onClick={handleOnSubmit}
            sx={{ maxWidth: 180 }}
          >
            ยืนยัน
          </Button>
        </DialogActions>
      </Dialog>

      {/* Ad box in the bottom of ImageGalleryDialog */}
      <AdBoxContainer>
        <img src="/assets/banner-generate-01.jpg" alt="ad" width="100%" />
      </AdBoxContainer>
    </>
  );
};

export default ImageGalleryDialog;
